import { Axios } from "../httpService";


export const ListFileAddSanad = () => {
    return Axios.get('/Sanad/ListFileAddSanad');
  };
  
  export const AddFileSanad = async (formData, onProgress) => {
    return await Axios.post("/Sanad/AddFileSanad", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentage); // Pass the percentage to the callback
      },
    });
  };
  export const AddFileSanadByScan = async (formData) => {
    return await Axios.post("/Sanad/AddFileSanadByScan", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      
    });
  };
  export const DeleteFileSanad = (name) => {
      return Axios.delete(`/Sanad/DeleteFileSanad/${name}`);
    };
  export const DeleteAllfileSanad = () => {
      return Axios.delete(`/Sanad/DeleteAllfileSanad`);
    };
    export const addsettingsanad = (data) => {
        return Axios.post("/Sanad/addsettingsanad", data, {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,  
        });
      };
    export const OkSanad = (data) => {
        return Axios.post("/Sanad/OkSanad", data, {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,  
        });
      };